// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.inv-wizard {
  max-width: 900px;
}

.inv-steps {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 22px;
}

.inv-steps__item {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  min-width: 0;
  color: #ccc;
  font-size: 12px;
  font-weight: 600;
}
.inv-steps__item:last-child {
  flex: 0 0 auto;
}
.inv-steps__item::after {
  content: "";
  flex: 1;
  height: 2px;
  min-width: 18px;
  margin: 0 12px;
  background: #eef0f1;
  border-radius: 2px;
}
.inv-steps__item:last-child::after {
  display: none;
}
.inv-steps__item.is-done::after {
  background: rgb(0, 173, 208);
}

.inv-steps__num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eef0f1;
  color: #ccc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
}

.inv-steps__label {
  white-space: nowrap;
}

.inv-steps__item {
  cursor: pointer;
}

.inv-steps__item:hover .inv-steps__label {
  color: rgb(0, 173, 208);
}

.inv-steps__item.is-active {
  color: rgb(0, 173, 208);
}

.inv-steps__item.is-active .inv-steps__num,
.inv-steps__item.is-done .inv-steps__num {
  background: rgb(0, 173, 208);
  color: #fff;
}

@media (max-width: 560px) {
  .inv-steps__label {
    display: none;
  }
}
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.inv-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px 18px;
}

.inv-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.inv-form-grid .inv-field {
  margin-bottom: 0;
}

.inv-field--full, .inv-key-notice {
  grid-column: 1/-1;
}

.inv-field label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.inv-field .form-control,
.inv-org-row .form-control {
  height: auto;
  padding: 9px 12px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.inv-field .form-control::placeholder,
.inv-org-row .form-control::placeholder {
  color: #ccc;
}
.inv-field .form-control:focus,
.inv-org-row .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}

textarea.form-control {
  min-height: 240px;
  resize: vertical;
  line-height: 1.6;
}

.inv-field select.form-control,
.inv-org-row select.form-control {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 34px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.inv-field .form-control.ng-invalid.ng-touched,
.inv-org-row .form-control.ng-invalid.ng-touched {
  border-color: rgb(245, 67, 89);
}
.inv-field .form-control.ng-invalid.ng-touched:focus,
.inv-org-row .form-control.ng-invalid.ng-touched:focus {
  border-color: rgb(245, 67, 89);
  box-shadow: 0 0 0 3px rgba(245, 67, 89, 0.12);
}

.inv-error {
  margin-top: 5px;
  font-size: 11.5px;
  line-height: 1.4;
  color: rgb(245, 67, 89);
}

.inv-hint {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: #ccc;
}

.inv-locked {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 8px 12px;
  border: 1px dashed #e7eaec;
  border-radius: 6px;
  background: #f1f1f2;
  cursor: default;
}
.inv-locked__value {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #ccc;
  line-height: 1.4;
}
.inv-locked__icon {
  flex: 0 0 auto;
  font-size: 11px;
  color: #ccc;
  opacity: 0.75;
}

.inv-locked-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: -6px 0 0;
  font-size: 11.5px;
  line-height: 1.45;
  color: #ccc;
}
.inv-locked-note::before {
  content: "\\f05a";
  font-family: FontAwesome;
  font-size: 11px;
  line-height: 1.45;
  opacity: 0.8;
}

.inv-note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 173, 208, 0.28);
  border-radius: 8px;
  background: rgba(0, 173, 208, 0.06);
}
.inv-note__icon {
  flex: 0 0 auto;
  margin-top: 1px;
  font-size: 13px;
  color: rgb(0, 173, 208);
}
.inv-note__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #676a6c;
}
.inv-note__text strong {
  font-weight: 600;
}

.inv-field--full {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #676a6c;
}

.inv-role-note {
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 16px;
  font-size: 12.5px;
  line-height: 1.55;
  color: #676a6c;
}
.inv-role-note ul {
  margin: 6px 0 0;
  padding-left: 18px;
}
.inv-role-note li {
  margin: 2px 0;
}
.inv-role-note strong {
  color: #6d6e71;
}

.inv-key-notice {
  background: #fff8e6;
  border: 1px solid #f3e0a8;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
  color: #8a6d1a;
  line-height: 1.5;
}

.inv-section-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin: 26px 0 16px;
  padding-top: 20px;
  border-top: 1px solid #e7eaec;
}

@media (min-width: 720px) {
  .inv-form-grid--pairs {
    grid-template-columns: 1fr 1fr;
  }
}
.inv-orgs {
  margin-bottom: 4px;
}

.inv-orgs__empty {
  padding: 14px;
  text-align: center;
  font-size: 12px;
  color: #ccc;
  background: #f1f1f2;
  border: 1px dashed #e7eaec;
  border-radius: 6px;
}

.inv-org-row {
  display: grid;
  grid-template-columns: 1fr 1.4fr 130px auto 32px;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
}
.inv-org-row__notify {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #ccc;
  white-space: nowrap;
  cursor: pointer;
}
.inv-org-row__notify input {
  margin: 0;
  cursor: pointer;
}
.inv-org-row__remove {
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: rgba(245, 67, 89, 0.08);
  color: rgb(245, 67, 89);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: all 0.15s ease;
}
.inv-org-row__remove:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  transform: scale(1.06);
}

.inv-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 2px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.06);
  border: 1px dashed rgba(0, 173, 208, 0.45);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.inv-add-btn:hover {
  background: rgba(0, 173, 208, 0.12);
  border-style: solid;
}

.inv-messages__note {
  font-size: 13px;
  color: #ccc;
  margin: 0 0 14px;
}

.inv-send-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  color: #676a6c;
  background: rgba(0, 173, 208, 0.05);
  border: 1px solid rgba(0, 173, 208, 0.18);
}
.inv-send-note .fa {
  color: rgb(0, 173, 208);
  font-size: 14px;
  margin-top: 1px;
}

.inv-mail {
  margin-top: 4px;
}

.inv-mail__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.inv-mail__bar label {
  margin-bottom: 0;
}

.inv-mail__tabs {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 7px;
}

.inv-mail__tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: none;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #ccc;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.inv-mail__tab .fa {
  font-size: 11px;
}
.inv-mail__tab:hover {
  color: #676a6c;
}
.inv-mail__tab.is-active {
  background: #fff;
  color: rgb(0, 173, 208);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

textarea.inv-mail__body {
  min-height: 300px;
}

.inv-mail__preview {
  min-height: 300px;
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #676a6c;
  overflow-y: auto;
  max-height: 46vh;
}
.inv-mail__preview pre {
  white-space: pre-wrap;
  font-family: inherit;
  margin: 0;
  line-height: 1.6;
}

.inv-wizard__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e7eaec;
}

.inv-wizard__cancel {
  color: rgb(0, 173, 208);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.inv-wizard__cancel:hover {
  text-decoration: underline;
}

.inv-wizard__actions {
  display: flex;
  gap: 10px;
}

.inv-wizard__footer .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  line-height: 1.4;
  box-shadow: none;
  transition: all 0.15s ease;
}

.inv-wizard__footer .btn-primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.inv-wizard__footer .btn-primary:hover {
  background: #569c21;
  border-color: #569c21;
}

.inv-wizard__footer .btn-white {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.inv-wizard__footer .btn-white:hover {
  background: #f1f1f2;
  border-color: #ccc;
}

@media (max-width: 640px) {
  .inv-form-grid {
    grid-template-columns: 1fr;
  }
  .inv-org-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/invitations/create/invitation-create.component.scss","webpack://./src/app/components/invitations/_inv-form.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EAAc,gBAAA;AAiZd;;AA9YA;EAAa,aAAA;EAAe,gBAAA;EAAkB,UAAA;EAAY,gBAAA;AAqZ1D;;AAnZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WD8BkB;EC7BlB,eAAA;EACA,gBAAA;AAsZF;AApZE;EAAe,cAAA;AAuZjB;AApZE;EACE,WAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAsZJ;AApZE;EAAsB,aAAA;AAuZxB;AApZE;EAAmB,4BDVL;ACiahB;;AApZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WDGkB;ECFlB,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAuZF;;AArZA;EAAoB,mBAAA;AAyZpB;;AAtZA;EAAmB,eAAA;AA0ZnB;;AAzZA;EAA2C,uBD7B3B;AC0bhB;;AA5ZA;EAA6B,uBD9Bb;AC8bhB;;AA/ZA;;EAC2C,4BDhC3B;ECgCuD,WAAA;AAoavE;;AAlaA;EACE;IAAoB,aAAA;EAsapB;AACF;ADhWA;EACE,eAAA;ACkWF;;AD/VA;EACE,aAAA;EACA,eAAA;ACkWF;;AD/VA;EACE,sBAAA;ACkWF;;AD/VA;EACE,8BAAA;ACkWF;;AD/VA;EACE,gBAAA;ACkWF;;AD/VA;EACE,gBAAA;ACkWF;;AD/VA;EACE,aAAA;ACkWF;;AD/VA;EACE,gBAAA;ACkWF;;ADpVE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuVJ;ADrVI;;;;;;EACE,gBAAA;AC4VN;ADxVE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqcX;ADxVI;EALF;;IAMI,eA/GY;EC2chB;AACF;ADzVE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4cX;ADzVI;EALF;;IAMI,eArHY;ECkdhB;AACF;AD1VE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmdX;AD1VI;EALF;;IAMI,eA3HY;ECydhB;AACF;AD3VE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0dX;AD1VE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4dX;ADzVE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8dX;ADrVE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuVJ;ADrVI;EACE,gBAAA;ACuVN;ADpVI;EAXF;IAYI,eAAA;ECuVJ;AACF;ADpVE;;EAEE,UAAA;EACA,SAAA;ACsVJ;ADnVE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqVJ;;ADjVA;EACE,sBAxNQ;AC4iBV;;ADjVA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoVF;ADlVE;EALF;IAMI,cAAA;ECqVF;AACF;ADnVE;EACE,iBA1Ka;AC+fjB;ADlVE;EACE,gBApLa;EAqLb,WAAA;ACoVJ;;AD/UE;EACE,kBAAA;ACkVJ;AD/UE;EACE,iBAAA;ACiVJ;;AD5UE;EACE,aAAA;AC+UJ;;AD3UA;EACE,kBAAA;AC8UF;AD5UE;EACE,mBAAA;AC8UJ;AD1UI;EACE,sBAAA;AC4UN;ADxUE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwiBnB;ADxUI;EACE,sBAAA;AC0UN;ADvUI;EAVF;IAWI,eApOoB;EC8iBxB;AACF;ADvUE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyUJ;ADvUI;EACE,sBAAA;ACyUN;ADtUI;EACE,WAAA;ACwUN;ADrUI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmqBZ;;ADlUA;EACE,mBA1PO;AC+jBT;ADnUE;EAHF;IAII,mBAAA;ECsUF;AACF;ADpUE;EACE,mBAAA;ACsUJ;ADnUE;EACE,aArQK;AC0kBT;ADnUI;EAHF;IAII,aAAA;ECsUJ;AACF;ADpUI;EACE,aAAA;ACsUN;;ADjUA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoUF;ADlUE;EACE,eAAA;ACoUJ;ADjUE;EACE,sCAAA;ACmUJ;ADhUE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkUJ;;ADnTE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsTJ;ADpTI;EACE,kBAAA;ACsTN;ADnTI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqTN;;ADhTA;EACE,8BAAA;ACmTF;;ADhTA;EACE,8BAAA;ACmTF;;ADhTA;EACE,+BAAA;ACmTF;;ADhTA;EACE,8BAAA;ACmTF;;ADhTA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmTF;ADjTE;EACE,2BAAA;EACA,mBAAA;ACmTJ;ADhTE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4tBX;AD/SE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiTJ;AD9SE;EACE,yBAjckB;EAkclB,cArciB;ACqvBrB;AD7SE;EACE,yBAvbS;EAwbT,WA1bO;ACyuBX;AD7SI;EACE,6BAAA;AC+SN;;AD1SA;EACE;IACE,uBAAA;EC6SF;ED1SA;IACE,yBAAA;EC4SF;AACF;ADzSA;EACE,8BAAA;AC2SF;;ADxSA;EACE,8BAAA;AC2SF;;ADxSA;EACE,+BAAA;AC2SF;;ADxSA;EACE,8BAAA;AC2SF;;ADxSA;EACE,qBAAA;AC2SF;;ADxSA;EACE,UAAA;AC2SF;ADzSE;EACE,qBAAA;AC2SJ;;ADvSA;EACE,UAAA;AC0SF;;ADtSE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwSJ;ADrSM;EACE,mBAAA;ACuSR;ADlSE;EACE,2BAAA;ACoSJ;ADjSE;EACE,uBAAA;ACmSJ;ADhSE;EACE,mBAAA;ACkSJ;;AD7RE;EACE,mBAAA;ACgSJ;AD7RE;EACE,yBAAA;AC+RJ;AD5RE;EACE,sBAAA;AC8RJ;AD3RE;EACE,uBAAA;AC6RJ;AD1RE;EACE,oBAAA;AC4RJ;;ACp2BA;EAAiB,aAAA;EAAe,0BAAA;EAA4B,cAAA;AD02B5D;;ACz2BA;EAAa,aAAA;EAAe,sBAAA;EAAwB,mBAAA;AD+2BpD;;AC92BA;EAA4B,gBAAA;ADk3B5B;;ACj3BA;EAAoC,iBAAA;ADq3BpC;;ACn3BA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFmBmB;EElBnB,kBAAA;EACA,wEFvBW;AC64Bb;;ACn3BA;;EAEE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wEF/BW;EEgCX,cFGmB;EEFnB,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wDAAA;ADs3BF;ACp3BE;;EAAiB,WFGC;ACq3BpB;ACv3BE;;EAAU,8BFnBI;EEmB0B,4CAAA;EAAiD,aAAA;AD63B3F;;AC33BA;EAAwB,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;ADi4B7D;;AC33BA;;EAEE,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,wQAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;AD83BF;;AC13BA;;EAEE,8BFtCgB;ACm6BlB;AC53BE;;EAAU,8BFvCM;EEuC0B,6CAAA;ADi4B5C;;AC/3BA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBF7CgB;AC+6BlB;;AC/3BA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WFlCkB;ACo6BpB;;AC73BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBF9CoB;EE+CpB,eAAA;ADg4BF;AC93BE;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,WFtDgB;EEuDhB,gBAAA;ADg4BJ;AC93BE;EACE,cAAA;EACA,eAAA;EACA,WF5DgB;EE6DhB,aAAA;ADg4BJ;;AC33BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WFzEkB;ACu8BpB;AC53BE;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AD83BJ;;ACz3BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mCAAA;AD43BF;AC13BE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBFvHY;ACm/BhB;AC13BE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cF/GiB;AC2+BrB;AC33BI;EAAS,gBAAA;AD83Bb;;ACz3BA;EACE,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cF1HmB;ACs/BrB;;ACx3BA;EACE,mBFvHoB;EEwHpB,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cFtImB;ACigCrB;ACz3BE;EAAK,eAAA;EAAiB,kBAAA;AD63BxB;AC53BE;EAAK,aAAA;AD+3BP;AC93BE;EAAS,cFrIU;ACsgCrB;;AC73BA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ADg4BF;;AC53BA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFzJmB;EE0JnB,mBAAA;EACA,iBAAA;EACA,6BAAA;AD+3BF;;AC13BA;EACE;IAAwB,8BAAA;ED83BxB;AACF;AA3gCA;EAAY,kBAAA;AA8gCZ;;AA7gCA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WDzBkB;EC0BlB,mBDzBoB;EC0BpB,0BAAA;EACA,kBAAA;AAghCF;;AA7gCA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAghCF;AA9gCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WD7CgB;EC8ChB,mBAAA;EACA,eAAA;AAghCJ;AA/gCI;EAAQ,SAAA;EAAW,eAAA;AAmhCvB;AAhhCE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,mCAAA;EACA,uBD3Ec;EC4Ed,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AAkhCJ;AAjhCI;EAAU,4BDlFI;ECkF0B,WAAA;EAAa,sBAAA;AAshCzD;;AAlhCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDtHW;ECuHX,uBDlGc;ECmGd,mCAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAqhCF;AAphCE;EAAU,mCAAA;EAAwC,mBAAA;AAwhCpD;;AAphCA;EAAsB,eAAA;EAAiB,WDvFnB;ECuF8C,gBAAA;AA0hClE;;AAzhCA;EACE,aAAA;EAAe,uBAAA;EAAyB,QAAA;EACxC,gBAAA;EAAkB,kBAAA;EAAoB,kBAAA;EACtC,iBAAA;EAAmB,gBAAA;EAAkB,cDlGlB;ECmGnB,mCAAA;EAAwC,yCAAA;AAmiC1C;AAliCE;EAAM,uBDlHQ;ECkHe,eAAA;EAAiB,eAAA;AAuiChD;;AApiCA;EAAY,eAAA;AAwiCZ;;AAviCA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,kBAAA;AA8iCrF;;AA7iCA;EAAuB,gBAAA;AAijCvB;;AAhjCA;EACE,oBAAA;EAAsB,QAAA;EAAU,YAAA;EAChC,mBDpGoB;ECoGc,yBAAA;EAAiC,kBAAA;AAujCrE;;AArjCA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,SAAA;EAAW,gBAAA;EAAkB,eAAA;EAC7B,iBAAA;EAAmB,kBAAA;EACnB,eAAA;EAAiB,gBAAA;EAAkB,wEDrJxB;ECqJkD,WD3G3C;EC4GlB,yDAAA;AAgkCF;AA/jCE;EAAM,eAAA;AAkkCR;AAjkCE;EAAU,cDrHS;ACyrCrB;AAnkCE;EAAc,gBAAA;EAAkB,uBDpIlB;ECoIyC,yCAAA;AAwkCzD;;AArkCA;EAA0B,iBAAA;AAykC1B;;AAxkCA;EACE,iBAAA;EACA,mBDpHoB;ECoHc,yBAAA;EAAiC,kBAAA;EACnE,kBAAA;EAAoB,eAAA;EAAiB,cD7HlB;EC6H8C,gBAAA;EAAkB,gBAAA;AAilCrF;AAhlCE;EAAM,qBAAA;EAAuB,oBAAA;EAAsB,SAAA;EAAW,gBAAA;AAslChE;;AAllCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAqlCF;;AAnlCA;EACE,uBDzJc;EC0Jd,eAAA;EACA,eAAA;EACA,gBAAA;AAslCF;AArlCE;EAAU,0BAAA;AAwlCZ;;AAtlCA;EAAuB,aAAA;EAAe,SAAA;AA2lCtC;;AAzlCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED7LW;EC8LX,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;AA4lCF;;AA1lCA;EACE,6BD/Kc;ECgLd,WAAA;EACA,+BDjLc;AC8wChB;AA5lCE;EAAU,mBAAA;EAAwC,qBAAA;AAgmCpD;;AA9lCA;EACE,gBAAA;EACA,cD1KmB;EC2KnB,qBD7Ja;AC8vCf;AAhmCE;EAAU,mBDpKU;ECoKwB,kBDrK1B;ACywCpB;;AAjmCA;EACE;IAAiB,0BAAA;EAqmCjB;EApmCA;IAAe,0BAAA;IAA4B,QAAA;EAwmC3C;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n\n.inv-wizard { max-width: 900px; }\n\n// ── Stepper (numbered circles joined by connector lines) ──\n.inv-steps { display: flex; list-style: none; padding: 0; margin: 0 0 22px; }\n\n.inv-steps__item {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex: 1;\n  min-width: 0;\n  color: $color-neutral-mid;\n  font-size: 12px;\n  font-weight: 600;\n\n  &:last-child { flex: 0 0 auto; }\n\n  // connector line running to the next step's circle\n  &::after {\n    content: '';\n    flex: 1;\n    height: 2px;\n    min-width: 18px;\n    margin: 0 12px;\n    background: #eef0f1;\n    border-radius: 2px;\n  }\n  &:last-child::after { display: none; }\n\n  // completed step → its outgoing line is filled (progress)\n  &.is-done::after { background: $clarify-color; }\n}\n\n.inv-steps__num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #eef0f1;\n  color: $color-neutral-mid;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n.inv-steps__label { white-space: nowrap; }\n\n// Step titles are live — click to jump back (or forward through valid steps).\n.inv-steps__item { cursor: pointer; }\n.inv-steps__item:hover .inv-steps__label { color: $clarify-color; }\n.inv-steps__item.is-active { color: $clarify-color; }\n.inv-steps__item.is-active .inv-steps__num,\n.inv-steps__item.is-done .inv-steps__num { background: $clarify-color; color: #fff; }\n\n@media (max-width: 560px) {\n  .inv-steps__label { display: none; }\n}\n\n@import \"../_inv-form\";\n\n// ── Organizers ───────────────────────────────\n.inv-orgs { margin-bottom: 4px; }\n.inv-orgs__empty {\n  padding: 14px;\n  text-align: center;\n  font-size: 12px;\n  color: $color-neutral-mid;\n  background: $color-neutral-light;\n  border: 1px dashed $color-grey-1;\n  border-radius: 6px;\n}\n\n.inv-org-row {\n  display: grid;\n  grid-template-columns: 1fr 1.4fr 130px auto 32px;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 8px;\n\n  &__notify {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin: 0;\n    font-size: 12px;\n    font-weight: 500;\n    color: $color-neutral-mid;\n    white-space: nowrap;\n    cursor: pointer;\n    input { margin: 0; cursor: pointer; }\n  }\n\n  &__remove {\n    width: 32px;\n    height: 32px;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    background: rgba($implement-color, 0.08);\n    color: $implement-color;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    transition: all 0.15s ease;\n    &:hover { background: $implement-color; color: #fff; transform: scale(1.06); }\n  }\n}\n\n.inv-add-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 4px 0 2px;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: $font-stack;\n  color: $clarify-color;\n  background: rgba($clarify-color, 0.06);\n  border: 1px dashed rgba($clarify-color, 0.45);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  &:hover { background: rgba($clarify-color, 0.12); border-style: solid; }\n}\n\n// Messages step (invitation letter)\n.inv-messages__note { font-size: 13px; color: $color-neutral-mid; margin: 0 0 14px; }\n.inv-send-note {\n  display: flex; align-items: flex-start; gap: 8px;\n  margin-top: 14px; padding: 10px 12px; border-radius: 8px;\n  font-size: 12.5px; line-height: 1.5; color: $body-content-color;\n  background: rgba($clarify-color, 0.05); border: 1px solid rgba($clarify-color, 0.18);\n  .fa { color: $clarify-color; font-size: 14px; margin-top: 1px; }\n}\n// Invite email: Edit / Preview toggle sharing one area (same footprint either way).\n.inv-mail { margin-top: 4px; }\n.inv-mail__bar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }\n.inv-mail__bar label { margin-bottom: 0; }\n.inv-mail__tabs {\n  display: inline-flex; gap: 2px; padding: 2px;\n  background: $color-neutral-light; border: 1px solid $color-grey-1; border-radius: 7px;\n}\n.inv-mail__tab {\n  display: inline-flex; align-items: center; gap: 5px;\n  border: 0; background: none; cursor: pointer;\n  padding: 4px 12px; border-radius: 5px;\n  font-size: 12px; font-weight: 600; font-family: $font-stack; color: $color-neutral-mid;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  .fa { font-size: 11px; }\n  &:hover { color: $body-content-color; }\n  &.is-active { background: #fff; color: $clarify-color; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08); }\n}\n// Editor and preview share the same height so toggling doesn't shift the layout.\ntextarea.inv-mail__body { min-height: 300px; }\n.inv-mail__preview {\n  min-height: 300px;\n  background: $color-neutral-light; border: 1px solid $color-grey-1; border-radius: 6px;\n  padding: 12px 14px; font-size: 13px; color: $body-content-color; overflow-y: auto; max-height: 46vh;\n  pre { white-space: pre-wrap; font-family: inherit; margin: 0; line-height: 1.6; }\n}\n\n// ── Footer + CTAs (refined, matches the modal aesthetic) ──\n.inv-wizard__footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid $color-grey-1;\n}\n.inv-wizard__cancel {\n  color: $clarify-color;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  &:hover { text-decoration: underline; }\n}\n.inv-wizard__actions { display: flex; gap: 10px; }\n\n.inv-wizard__footer .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  line-height: 1.4;\n  box-shadow: none;\n  transition: all 0.15s ease;\n}\n.inv-wizard__footer .btn-primary {\n  background: $develop-color;\n  color: #fff;\n  border-color: $develop-color;\n  &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n}\n.inv-wizard__footer .btn-white {\n  background: #fff;\n  color: $body-content-color;\n  border-color: $color-grey-1;\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n}\n\n@media (max-width: 640px) {\n  .inv-form-grid { grid-template-columns: 1fr; }\n  .inv-org-row { grid-template-columns: 1fr; gap: 6px; }\n}\n","// Shared invitation form language — the field grid, labels, controls, validation and\n// notes used by app-invitation-step-details / -step-schedule.\n//\n// This lives in a partial rather than invitation-create.component.scss because those steps\n// render in TWO hosts: the create wizard and the edit modal. Component styles (encapsulation\n// None) are only injected once their component is first instantiated, and app-invitation-create\n// only exists on the invitations LIST page — so opening Edit from a detail page you deep-linked\n// to left the whole form unstyled. Both hosts now @import this.\n\n@import \"../../../assets/styles/variables\";\n\n// ── Form grid + fields ───────────────────────\n.inv-form-grid { display: grid; grid-template-columns: 1fr; gap: 16px 18px; }\n.inv-field { display: flex; flex-direction: column; margin-bottom: 16px; }\n.inv-form-grid .inv-field { margin-bottom: 0; } // grid uses gap; reset here\n.inv-field--full, .inv-key-notice { grid-column: 1 / -1; }\n\n.inv-field label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $color-neutral-dark;\n  margin-bottom: 6px;\n  font-family: $font-stack;\n}\n\n.inv-field .form-control,\n.inv-org-row .form-control {\n  height: auto;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &::placeholder { color: $color-neutral-mid; }\n  &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); outline: none; }\n}\ntextarea.form-control { min-height: 240px; resize: vertical; line-height: 1.6; }\n\n// Native selects render as an OS widget that ignores the box styling above — only the font came\n// through, so they sat short and square next to the inputs and the Organization combobox. Opting\n// out of the widget lets the shared rule apply, and we draw the chevron ourselves (inline SVG so\n// there's no asset request). Padding-right clears the arrow.\n.inv-field select.form-control,\n.inv-org-row select.form-control {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  cursor: pointer;\n}\n\n// Validation: red border on touched-invalid controls + inline message under the field.\n.inv-field .form-control.ng-invalid.ng-touched,\n.inv-org-row .form-control.ng-invalid.ng-touched {\n  border-color: $implement-color;\n  &:focus { border-color: $implement-color; box-shadow: 0 0 0 3px rgba($implement-color, 0.12); }\n}\n.inv-error {\n  margin-top: 5px;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: $implement-color;\n}\n// Explanatory note under a field — states a default the form applied for you.\n.inv-hint {\n  margin: 5px 0 0;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: $color-neutral-mid;\n}\n\n// Read-only field value (edit modal) — keeps .form-control's box so the form's rhythm holds,\n// but reads as inert: muted fill, dashed edge, no focus ring, a trailing lock.\n.inv-locked {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n  padding: 8px 12px;\n  border: 1px dashed $color-grey-1;\n  border-radius: 6px;\n  background: $color-neutral-light;\n  cursor: default;\n\n  &__value {\n    flex: 1;\n    min-width: 0;\n    font-size: 13px;\n    color: $color-neutral-mid;\n    line-height: 1.4;\n  }\n  &__icon {\n    flex: 0 0 auto;\n    font-size: 11px;\n    color: $color-neutral-mid;\n    opacity: 0.75;\n  }\n}\n\n// Explains the pair of locked fields above it — indented to read as their footnote.\n.inv-locked-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin: -6px 0 0;\n  font-size: 11.5px;\n  line-height: 1.45;\n  color: $color-neutral-mid;\n\n  &::before {\n    content: '\\f05a'; // fa-info-circle\n    font-family: FontAwesome;\n    font-size: 11px;\n    line-height: 1.45;\n    opacity: 0.8;\n  }\n}\n\n// Info callout — a constraint the user needs before they pick, not an error.\n.inv-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 10px 12px;\n  border: 1px solid rgba($clarify-color, 0.28);\n  border-radius: 8px;\n  background: rgba($clarify-color, 0.06);\n\n  &__icon {\n    flex: 0 0 auto;\n    margin-top: 1px;\n    font-size: 13px;\n    color: $clarify-color;\n  }\n  &__text {\n    margin: 0;\n    font-size: 12.5px;\n    line-height: 1.5;\n    color: $body-content-color;\n    strong { font-weight: 600; }\n  }\n}\n\n// follow-up checkbox row\n.inv-field--full {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: $body-content-color;\n}\n\n// organizer-role explainer note (step 2)\n.inv-role-note {\n  background: $color-neutral-light;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: $body-content-color;\n\n  ul { margin: 6px 0 0; padding-left: 18px; }\n  li { margin: 2px 0; }\n  strong { color: $color-neutral-dark; }\n}\n\n// inline profile-key notice\n.inv-key-notice {\n  background: #fff8e6;\n  border: 1px solid #f3e0a8;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 12px;\n  color: #8a6d1a;\n  line-height: 1.5;\n}\n\n// Section heading — a ruled divider so a long form reads as parts rather than one list.\n.inv-section-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $color-neutral-dark;\n  margin: 26px 0 16px;\n  padding-top: 20px;\n  border-top: 1px solid $color-grey-1;\n}\n\n// Date pairs sit side by side once there's room — the schedule is a sequence, and stacking\n// deadline over presentation over coaching buries the order in scroll.\n@media (min-width: 720px) {\n  .inv-form-grid--pairs { grid-template-columns: 1fr 1fr; }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
